import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ltx/phase-i/consultations/ophthalmologicExamination";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	ophthalmologicExamination: {
		id: "form.ophthalmologic_examination",
		defaultMessage: "Szemészeti szűrővizsgálat"
	},
	result: {
		id: "form.ophthalmologic_examination.result",
		defaultMessage: "Eltérés"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.result }] }]
};

export const node: LeafNode = {
	id: "ophthalmologicExamination",
	value: {
		title: messages.ophthalmologicExamination,
		validator,
		fieldset
	}
};
